import learnPartTwoRequest from '@apis/learn-part-two'
import {
  Box,
  VStack,
  HStack,
  Avatar,
  Text,
  Button,
  Flex,
  Icon,
} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateAudio,
  updateIsLoadingBot,
  updateMessages,
  updateUserIdea,
  updateUserIdeaHistoryId,
} from '@redux/learn-part-two/learnPartTwo'
import {CommonColors} from '@utils/CommonStyles'
import './index.css'
import {BsImage} from 'react-icons/bs'
import {BiSearch} from 'react-icons/bi'
import {AiOutlineStar} from 'react-icons/ai'
import {BsEmojiSmile} from 'react-icons/bs'
import UserMsg from './UserMsg'
import AvatarDefault from '@assets/images/avatar-msg-part-two.png'
import SuggestionMsg from './SuggestionMsg'

const PracticeSpeak = ({
  sessionId,
  setCurrentContentIndex,
}: {
  sessionId: string
  setCurrentContentIndex: any
}) => {
  const {messages, currentPhaseIndex, isLoadingBot} = useSelector(
    (state: any) => state.learnPartTwo,
  )
  const [practiceIdeaData, setPracticeIdeaData] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dispatch = useDispatch()

  useEffect(() => {
    getDataPracticeIdea()
  }, [])

  useEffect(() => {
    if (!practiceIdeaData) return
    let message = practiceIdeaData?.user_ideas[currentPhaseIndex]
    message = {...message, type: 'IDEA'}
    dispatch(updateMessages([message]))
    dispatch(updateUserIdeaHistoryId(message?.user_idea_history_id))

    const phase = practiceIdeaData?.phases?.find(
      (item: any) => item?.phase === message?.phase,
    )

    const audioData = {
      time: Date.now(),
      url: phase?.intro_audio,
    }

    dispatch(updateAudio(audioData))
  }, [practiceIdeaData, currentPhaseIndex])

  const getDataPracticeIdea = async () => {
    dispatch(updateIsLoadingBot(true))
    try {
      const params = {
        session_id: sessionId,
      }

      const res = await learnPartTwoRequest.getDataPracticeIdea(params)
      setPracticeIdeaData(res?.data?.data)
      dispatch(updateUserIdea(res?.data?.data?.user_ideas))

      if (
        res?.data?.data?.user_ideas?.length === 0 ||
        !res?.data?.data?.user_ideas
      ) {
        setCurrentContentIndex((prev: any) => prev + 1)
      }
    } catch (error) {}
    dispatch(updateIsLoadingBot(false))
    setIsLoading(false)
  }

  const getIndexPhase = (msg: any) => {
    return practiceIdeaData?.phases?.findIndex(
      (item: any) => item?.phase === msg?.phase,
    )
  }

  const getIcon = (index: number) => {
    switch (index) {
      case 0:
        return BsImage
      case 1:
        return BiSearch
      case 2:
        return AiOutlineStar
      case 3:
        return BsEmojiSmile
      default:
        return BsImage
    }
  }

  const renderMessage = (msg: any, index: number) => {
    switch (msg.type) {
      case 'BOT':
        return (
          <HStack
            key={index}
            align="start"
            spacing={4}
            className="user-message">
            <Avatar
              src={AvatarDefault}
              size="sm"
              borderRadius={'50%'}
              border={'2px solid #E4E7EC'}
            />
            <Box bg={'white'} p={'16px'} borderRadius={'12px'} maxWidth={'80%'}>
              <Text fontSize={'16px'}>{msg?.content}</Text>
            </Box>
          </HStack>
        )
      case 'USER':
        return <UserMsg key={index} msg={msg} />
      case 'IDEA':
        return (
          <HStack key={index} align="start" spacing={4}>
            <Avatar
              src={AvatarDefault}
              size="sm"
              borderRadius={'50%'}
              border={'2px solid #E4E7EC'}
            />
            <VStack
              maxWidth={'80%'}
              align="start"
              spacing={4}
              bg={'white'}
              p={'16px'}
              borderRadius={'12px'}>
              <Text fontSize={'16px'}>
                {practiceIdeaData?.phases[getIndexPhase(msg)]?.intro}
              </Text>
              <HStack spacing={4}>
                {practiceIdeaData?.phases?.map((phase: any, i: number) => (
                  <Button
                    key={i}
                    pointerEvents={'none'}
                    leftIcon={<Icon as={(getIcon(i) as any) || <></>} />}
                    variant="outline"
                    borderRadius="full"
                    fontWeight={'600'}
                    borderColor={
                      i <= getIndexPhase(msg) ? '#99CEFF' : '#E4E7EC'
                    }
                    bg={i <= getIndexPhase(msg) ? '#D6EBFF' : 'white'}
                    color={
                      i <= getIndexPhase(msg) ? CommonColors.primary : 'unset'
                    }>
                    {phase.phase_title}
                  </Button>
                ))}
              </HStack>
              <VStack align="start" spacing={2} pl={4}>
                <Text fontWeight="600" fontSize={'16px'}>
                  {msg.text}
                </Text>
                {msg?.user_idea?.map((idea: any, i: number) => (
                  <HStack key={i}>
                    <Box as="span" color="blue.500">
                      ✓
                    </Box>
                    <Text fontSize={'16px'}>{idea}</Text>
                  </HStack>
                ))}
              </VStack>
            </VStack>
          </HStack>
        )
      case 'SUGGESTION':
        return <SuggestionMsg msg={msg} />
      default:
        break
    }
  }

  return (
    <Flex flexDirection={'column'} gap={4}>
      {!isLoading &&
        messages.map((msg: any, index: number) => renderMessage(msg, index))}
      {isLoadingBot && (
        <HStack align="start" spacing={4}>
          <Avatar
            src={AvatarDefault}
            size="sm"
            borderRadius={'50%'}
            border={'2px solid #E4E7EC'}
          />
          <Box bg={'white'} p={'16px'} borderRadius={'12px'}>
            <Box className="loading-message"></Box>
          </Box>
        </HStack>
      )}
    </Flex>
  )
}

export default PracticeSpeak
